import { render, staticRenderFns } from "./AppBox.vue?vue&type=template&id=61d44eea&scoped=true&"
import script from "./AppBox.vue?vue&type=script&lang=js&"
export * from "./AppBox.vue?vue&type=script&lang=js&"
import style0 from "./AppBox.vue?vue&type=style&index=0&id=61d44eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d44eea",
  null
  
)

export default component.exports